import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { cn } from '../utils/cn';

interface TextInputProps {
  label: string;
  name: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  type?: string;
  placeholder?: string;
  error?: string;
  hint?: string;
  required?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  className?: string;
}

export default function TextInput({
  label, name, value, onChange, onBlur, type = 'text', placeholder, error, hint, required, disabled, readOnly, className,
}: TextInputProps) {
  const [showPw, setShowPw] = useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword ? (showPw ? 'text' : 'password') : type;

  return (
    <div className={cn('space-y-1', className)}>
      <label htmlFor={name} className="block text-xs font-medium text-content-secondary">
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <div className="relative">
        <input
          id={name}
          name={name}
          type={inputType}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          className={cn(
            'w-full rounded-lg border px-3 py-2 text-sm text-content-primary bg-surface-card placeholder:text-content-muted outline-none transition-colors',
            error ? 'border-danger focus:ring-1 focus:ring-danger' : 'border-border focus:border-primary focus:ring-1 focus:ring-primary',
            disabled && 'opacity-50 cursor-not-allowed',
            readOnly && 'bg-surface-card-hover cursor-default',
            isPassword && 'pr-10'
          )}
        />
        {isPassword && (
          <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-2 top-1/2 -translate-y-1/2 text-content-muted hover:text-content-primary">
            {showPw ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        )}
      </div>
      {error && <p className="text-xs text-danger">{error}</p>}
      {hint && !error && <p className="text-xs text-content-muted">{hint}</p>}
    </div>
  );
}
